import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const CostEstimatesContent = ({ setActiveFile }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <>
            <Helmet>
                <title>Pricing | We Are A Site</title>
                <meta name="description" content="Explore our transparent pricing and get a breakdown of what it costs to build and maintain your custom website." />
            </Helmet>
            <div className='CompanyInfoContent'>
                <div className='AboutWindowFunctionBar'>
                    <button
                        onClick={() => {
                            setActiveFile(null);
                            navigate('/about');
                        }}
                    >Back</button>
                    <button style={{ cursor: "not-allowed" }}>File</button>
                    <button style={{ cursor: "not-allowed" }}>Edit</button>
                    <button style={{ cursor: "not-allowed" }}>View</button>
                    <button style={{ cursor: "not-allowed" }}>Help</button>
                </div>
                <div className='CompanyInfoContentText'>
                    {/* <div className='CompanyInfoContentTextHeader'>
                    <img src='/images/AboutTextFile.png' alt='Cost Estimates' />
                    <div className='CompanyInfoContentTextInfo'>
                        <span className='BusinessAttribute BusinessName'>
                            <span className='BusinessLabel'>Document: </span>CostEstimates.txt
                        </span>
                        <span className='BusinessAttribute BusinessType'>
                            <span className='BusinessLabel'>Type: </span>Pricing Overview
                        </span>
                    </div>
                </div> */}
                    <div className='CompanyInfoContentTextParagraph'>
                        <h1>Cost Breakdown</h1>
                        <p>
                            All prices are estimates. Every project is a little different — let's chat (for free) and get you an exact quote 😊
                        </p>
                        <h2>Website Types</h2>
                        <table className='EstimateTable'>
                            <thead>
                                <tr>
                                    <th>Website Type</th>
                                    <th>What's Included</th>
                                    <th>Estimated Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-label="Website Type">Basic/Informational</td>
                                    <td data-label="What's Included">Homepage, About Us, Services, FAQ, Contact Form, Gallery</td>
                                    <td data-label="Estimated Cost">$1050</td>
                                </tr>
                                <tr>
                                    <td data-label="Website Type">Online Booking</td>
                                    <td data-label="What's Included">All basic pages + custom booking form and/or calendar</td>
                                    <td data-label="Estimated Cost">+$550</td>
                                </tr>
                                <tr>
                                    <td data-label="Website Type">Administration</td>
                                    <td data-label="What's Included">Extra site that pairs with Booking or E-commerce</td>
                                    <td data-label="Estimated Cost">+$950</td>
                                </tr>
                                <tr>
                                    <td data-label="Website Type">E-commerce</td>
                                    <td data-label="What's Included">All basic pages + setup for selling products online</td>
                                    <td data-label="Estimated Cost">~$5000</td>
                                </tr>
                            </tbody>
                        </table>


                        <h2>Additional Costs (Optional) - Offered after launch</h2>
                        <table className='EstimateTable'>
                            <thead>
                                <tr>
                                    <th>Other Services</th>
                                    <th>What's Included</th>
                                    <th>Estimated Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-label="Other Services">Warranty</td>
                                    <td data-label="What's Included">60 days of any fixes or content changes (changing pictures, etc.)</td>
                                    <td data-label="Estimated Cost">FREE</td>
                                </tr>
                                <tr>
                                    <td data-label="Other Services">Managed Web Services</td>
                                    <td data-label="What's Included">
                                        Hosting,
                                        Account Management,
                                        Minor Bug Fixes,
                                        Content Updates,
                                        Search Engine Optimization (SEO) Services,
                                        Analytics & Reporting,
                                        Speed Testing & Optimization
                                    </td>
                                    <td data-label="Estimated Cost">~$150 per month*</td>
                                </tr>
                                <tr>
                                    <td data-label="Other Services">Content Changes</td>
                                    <td data-label="What's Included">Making any changes to the site after the warranty</td>
                                    <td data-label="Estimated Cost">$100</td>
                                </tr>
                            </tbody>
                        </table><br />

                        <span className='CostsDisclaimer'>*The $150/month price is based on standard traffic and usage. If your site experiences high traffic or requires a subset of these services, please contact us directly for a custom plan.</span>

                        {/* <h2>Recurring Charges - To keep your website alive</h2>
                    <table className='EstimateTable'>
                        <thead>
                            <tr>
                                <th>Items</th>
                                <th>Why do you need it?</th>
                                <th>Estimated Cost</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td data-label="Items">Website Hosting</td>
                                <td data-label="Why do you need it?">Stores and shows your website to visitors</td>
                                <td data-label="Estimated Cost">$1-$10 monthly</td>
                            </tr>
                            <tr>
                                <td data-label="Items">Backend System</td>
                                <td data-label="Why do you need it?">Runs your website's behind-the-scenes features like booking, etc.</td>
                                <td data-label="Estimated Cost">$5-$30 monthly</td>
                            </tr>
                            <tr>
                                <td data-label="Items">Database</td>
                                <td data-label="Why do you need it?">Stores your data like appointments, clients, and settings</td>
                                <td data-label="Estimated Cost">$15-$60 monthly</td>
                            </tr>
                            <tr>
                                <td data-label="Items">Email Service</td>
                                <td data-label="Why do you need it?">Sends confirmation and reminder emails</td>
                                <td data-label="Estimated Cost">FREE-$19 monthly</td>
                            </tr>
                            <tr>
                                <td data-label="Items">Text Messages</td>
                                <td data-label="Why do you need it?">Sends SMS reminders or alerts</td>
                                <td data-label="Estimated Cost">$5-$10 monthly</td>
                            </tr>
                            <tr>
                                <td data-label="Items">Domain Name</td>
                                <td data-label="Why do you need it?">Your web address (like yourbusiness.com)</td>
                                <td data-label="Estimated Cost">$12 yearly</td>
                            </tr>
                            <tr>
                                <td data-label="Items">Payment Processing</td>
                                <td data-label="Why do you need it?">Handles online payments</td>
                                <td data-label="Estimated Cost">No fee</td>
                            </tr>
                        </tbody>
                    </table> */}
                    </div>
                </div>
            </div>
        </>

    );
};

export default CostEstimatesContent;
